import { computed, reactive, ref } from 'vue'
import { useQuery } from 'vue-query'
import { useStore } from 'vuex'

import { fetchMeetingList } from './vueQuery/fetch-meeting-list'

export const useFetchMeetingNotesList = (
  { page, search, sortedBy, searchFields, advisor_id, orderBy, hasLimit = true },
  options = {}
) => {
  const store = useStore()

  const limit = hasLimit ? 10 : computed(() => store.state.globalComponents.itemsPerPage.values.default)
  const reactiveId = computed(() => store.state.globalComponents.summaryInfoMemberId)

  const reactiveLimit = ref(limit)
  const reactiveOrderBy = ref(orderBy)
  const reactiveSortedBy = ref(sortedBy)
  const reactivePage = ref(page)
  const reactiveSearch = ref(search)
  const reactiveSearchFields = ref(searchFields)
  const reactiveAdvisorId = ref(advisor_id)
  const searchJoin = 'and'

  const queryKey = reactive([
    'tasks',
    {
      reactiveLimit,
      searchJoin,
      reactiveAdvisorId,
      reactiveSearchFields,
      reactiveOrderBy,
      reactiveSortedBy,
      reactivePage,
      reactiveId,
      reactiveSearch,
    },
  ])

  const pagination = reactive({})

  const query = useQuery(queryKey, {
    cacheTime: 0,
    retry: 0,
    queryFn: fetchMeetingList,
    select: ({ data, meta }) => {
      pagination.value = meta.pagination
      return data
    },
    ...options,
  })
  return {
    ...query,
    pagination,
  }
}
